import React from 'react';

import makeStyles from '@glass/web/modules/theme/makeStyles';

type AspectRatioProps = {
  className?: string;
  children: React.ReactNode;
  width: number;
  height: number;
};

const useStyles = makeStyles<Pick<AspectRatioProps, 'width' | 'height'>>()(
  (_, { width, height }) => ({
    root: {
      height: 0,
      overflow: 'hidden',
      paddingTop: `${(100 * height) / width}%`,
      position: 'relative',
    },
    inner: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
    },
  }),
);

function AspectRatio({ className, children, width = 1, height = 1 }: AspectRatioProps) {
  const { classes, cx } = useStyles({ width, height });
  return (
    <div className={cx(classes.root, className)}>
      <div className={classes.inner}>{children}</div>
    </div>
  );
}

export default React.memo(AspectRatio);
